// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__397Eg","calendarButtons":"ClockData_calendarButtons__3Yium"};